'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    Checkbox: ()=>Checkbox
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const checkbox_namespaceObject = require("@base-ui-components/react/checkbox");
const index_cjs_namespaceObject = require("../../CdnIcon/index.cjs");
const external_utils_index_cjs_namespaceObject = require("../../../utils/index.cjs");
const external_Checkbox_variants_cjs_namespaceObject = require("./Checkbox.variants.cjs");
const Checkbox = (props)=>{
    const { emphasis, checkboxClassName, disabled = false, value, checked = false, indeterminate = false, handleChange, ref, size = '20', required, isCheckboxGroup = false, ...restProps } = props;
    const iconName = getIconName({
        checked,
        showIndeterminate: indeterminate
    });
    const { root, indicator, icon } = (0, external_Checkbox_variants_cjs_namespaceObject.checkboxVariants)({
        size,
        emphasis,
        isCheckboxGroup
    });
    const onCheckedChange = (_ischecked, e)=>{
        if ('function' == typeof handleChange) handleChange(value, e);
    };
    const classes = (0, external_utils_index_cjs_namespaceObject.cn)(root(), checkboxClassName);
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(checkbox_namespaceObject.Checkbox.Root, {
        indeterminate: indeterminate,
        disabled: disabled,
        checked: checked,
        onCheckedChange: onCheckedChange,
        className: classes,
        inputRef: ref,
        value: value,
        required: required,
        ...restProps,
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(checkbox_namespaceObject.Checkbox.Indicator, {
            hidden: false,
            keepMounted: true,
            className: indicator(),
            children: iconName ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.CdnIcon, {
                className: icon(),
                size: size,
                iconName: iconName
            }) : null
        })
    });
};
function getIconName({ checked, showIndeterminate }) {
    let iconName;
    if (checked && !showIndeterminate) iconName = 'check';
    if (showIndeterminate) iconName = 'check_indeterminate_small';
    return iconName;
}
exports.Checkbox = __webpack_exports__.Checkbox;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "Checkbox"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
